module.exports = __webpack_public_path__ + "img/umajo.d032393c.png";